import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LandTitleNameDto } from '@cradua/data';
import Swal from 'sweetalert2';

interface ILandTitleName {
  LandTitleName: LandTitleNameDto[]
}

@Component({
  selector: 'cradua-previous-land-name-modal',
  templateUrl: './previous-land-name-modal.component.html',
  styleUrls: ['./previous-land-name-modal.component.scss']
})
export class PreviousLandNameModalComponent implements OnInit {

  landTitleNameForm: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<PreviousLandNameModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: ILandTitleName,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.landTitleNameForm = this.fb.group({LandTitleNames: this.fb.array([])});
    if(this.modalData.LandTitleName && this.modalData.LandTitleName.length) {
      this.setLandTitleName(this.modalData.LandTitleName);
    }
  }


  get landTitleNameFormArray() {
    return this.landTitleNameForm.get('LandTitleNames') as FormArray;
  }

  setLandTitleName(landTitleNames: LandTitleNameDto[]) {
    landTitleNames.forEach(land => {
      this.landTitleNameFormArray.push(this.fb.group({
        LandTitleName: land.LandTitleName,
        LandTitleRemarks: land.LandTitleRemarks
      }));
    })
  }

  addLandTitleName() {
    this.landTitleNameFormArray.insert(0, this.fb.group({
      LandTitleName: [''],
      LandTitleRemarks: ['']
    }));
  }

  onDelete( index: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        // this.dispatchDelete.emit(id);
        this.landTitleNameFormArray.removeAt(index);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(value) {
    this.dialogRef.close(value.LandTitleNames);
  }

  onClose() {
    this.dialogRef.close();
  }


}
